import { useQuery } from '@tanstack/react-query';

import { WISHLIST_PORTFOLIO_SUMMARY_CACHE } from '@app/client/resources/fantasy';
import { callGetWishlistsSummary } from '@app/client/resources/wishlists';

type UseGetWishlistSummaryDataProps = {
    providedSlug: string;
    disabled?: boolean;
};
export const useGetWishlistSummaryData = ({ providedSlug, disabled }: UseGetWishlistSummaryDataProps) => {
    const cache = [WISHLIST_PORTFOLIO_SUMMARY_CACHE, providedSlug];

    return useQuery(
        cache,
        ({ signal }) =>
            callGetWishlistsSummary({
                slug: providedSlug,
                settings: {
                    signal,
                },
            }),
        {
            retry: true,
            keepPreviousData: true,
            enabled: Boolean(providedSlug) && !disabled,
            select: (r) => {
                if (r?.ok && r.value) {
                    return r.value;
                }
            },
        },
    );
};
